const getInputValue = (selector, defaultVal = 0) => {
  const element = document.querySelector(selector);
  return (element && element.value) || defaultVal;
}

const getElementSiblings = (element, selector) => {
  if (!element.parentElement) {
    return [];
  }

  const children = selector
      ? element.parentElement.querySelectorAll(`:scope > ${selector}`)
      : element.parentElement.childNodes;

  return Array.prototype.filter.call(children, el => el !== element);
}

export {getInputValue, getElementSiblings}
